export default __webpack_public_path__ + "static/media/ofit.6669ec52.png";